import axios from '../../helpers/axios/axios.service';

export const dashboardApi = {
  getDashboardStatistics: async () => {
    return await axios.get(`/stats`);
  },
};
